import { PageHero, Reveal, useSettings } from "@/components/shared";

const Section = ({ title, children }) => (
  <div className="border-b border-white/5 py-10">
    <h2 className="text-xl font-semibold tracking-tight text-ivory">{title}</h2>
    <div className="mt-4 space-y-4 text-sm leading-relaxed text-ivory/55">{children}</div>
  </div>
);

const PAGES = {
  "mentions-legales": {
    overline: "Informations légales",
    title: "Mentions légales",
    content: (
      <>
        <Section title="Éditeur du site">
          <p>
            Palais Maasaï — 87 rue Berbisey, 21000 Dijon, France.
            <br />
            Téléphone : 06 67 80 22 35 — Email : lepmaasai@gmail.com
          </p>
          <p>Directeur de la publication : le gérant de l'établissement Palais Maasaï.</p>
        </Section>
        <Section title="Hébergement">
          <p>
            Ce site est hébergé par un prestataire professionnel garantissant un niveau de sécurité
            et de disponibilité conforme aux standards en vigueur. Les coordonnées complètes de
            l'hébergeur sont disponibles sur demande à l'adresse lepmaasai@gmail.com.
          </p>
        </Section>
        <Section title="Propriété intellectuelle">
          <p>
            L'ensemble des contenus du site (textes, visuels, logo, identité graphique) est la
            propriété exclusive du Palais Maasaï, sauf mention contraire. Toute reproduction,
            représentation ou diffusion, totale ou partielle, sans autorisation écrite préalable est
            interdite.
          </p>
        </Section>
        <Section title="Responsabilité">
          <p>
            Les informations publiées sur ce site (carte, horaires, tarifs) sont données à titre
            indicatif et peuvent évoluer. Le Palais Maasaï ne saurait être tenu responsable des
            erreurs ou omissions, ni de l'utilisation qui pourrait être faite de ces informations.
          </p>
        </Section>
      </>
    ),
  },
  "politique-de-confidentialite": {
    overline: "Vos données",
    title: "Politique de confidentialité",
    content: (
      <>
        <Section title="Données collectées">
          <p>
            Dans le cadre de nos services, nous collectons les données que vous nous transmettez via
            le formulaire de réservation et le formulaire de contact : nom, prénom, adresse email,
            numéro de téléphone, ainsi que les informations relatives à votre réservation (date,
            horaire, nombre de convives, message libre).
          </p>
        </Section>
        <Section title="Finalités et base légale">
          <p>
            Ces données sont utilisées exclusivement pour traiter vos demandes de réservation et
            répondre à vos messages (exécution de mesures précontractuelles et intérêt légitime,
            conformément au RGPD — Règlement (UE) 2016/679).
          </p>
        </Section>
        <Section title="Durée de conservation">
          <p>
            Les données de réservation et de contact sont conservées pour une durée maximale de 3
            ans à compter de votre dernier échange avec nous, sauf obligation légale contraire.
          </p>
        </Section>
        <Section title="Destinataires">
          <p>
            Vos données sont destinées uniquement à l'équipe du Palais Maasaï. Elles ne sont ni
            vendues, ni cédées à des tiers à des fins commerciales.
          </p>
        </Section>
        <Section title="Vos droits">
          <p>
            Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit
            d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité
            de vos données. Pour exercer ces droits, écrivez à lepmaasai@gmail.com. Vous pouvez
            également introduire une réclamation auprès de la CNIL (www.cnil.fr).
          </p>
        </Section>
      </>
    ),
  },
  cgv: {
    overline: "Nos conditions",
    title: "Conditions Générales de Vente",
    content: (
      <>
        <Section title="Objet">
          <p>
            Les présentes Conditions Générales de Vente s'appliquent à toute réservation effectuée
            auprès du Palais Maasaï, 87 rue Berbisey, 21000 Dijon, notamment via le formulaire de
            réservation en ligne avec paiement d'un acompte.
          </p>
        </Section>
        <Section title="Réservation et acompte">
          <p>
            Toute réservation est confirmée uniquement après le paiement en ligne d'un acompte.
          </p>
          <p>
            De 1 à 4 personnes : acompte correspondant au prix d'un plat par personne (montant
            défini par le restaurant, multiplié par le nombre de convives).
          </p>
          <p>
            À partir de 5 personnes : les clients choisissent au minimum un plat par personne au
            moment de la réservation ; le système calcule le montant estimé et demande un acompte
            de 30 % de ce montant.
          </p>
          <p>
            Dans tous les cas, l'acompte est automatiquement déduit de la facture finale lorsque
            les clients se présentent au restaurant.
          </p>
        </Section>
        <Section title="Annulation et remboursement">
          <p>
            Toute réservation annulée plus de 24 heures avant l'heure prévue pourra être remboursée
            selon les présentes conditions.
          </p>
          <p>
            Toute réservation effectuée le jour même reste remboursable uniquement si elle est
            annulée plus d'une heure avant l'heure réservée.
          </p>
          <p>
            Toute réservation effectuée moins d'une heure avant l'heure choisie devient
            automatiquement non remboursable.
          </p>
          <p>
            Toute absence sans annulation (« No Show ») entraîne la conservation intégrale de
            l'acompte.
          </p>
        </Section>
        <Section title="Retard et annulation par le restaurant">
          <p>
            En cas de retard important non signalé, le restaurant se réserve la possibilité
            d'annuler la réservation, sans remboursement de l'acompte.
          </p>
          <p>
            Le restaurant pourra annuler une réservation en cas de force majeure : dans ce cas,
            l'acompte sera intégralement remboursé.
          </p>
          <p>
            Le restaurant se réserve le droit de refuser une réservation en cas de comportement
            inapproprié.
          </p>
        </Section>
        <Section title="Paiement sécurisé">
          <p>
            Le paiement de l'acompte est sécurisé via Stripe. Les données bancaires ne transitent
            jamais par nos serveurs et ne sont pas conservées par le restaurant.
          </p>
        </Section>
        <Section title="Litiges">
          <p>
            En cas de litige, une solution amiable sera recherchée en priorité. À défaut, les
            tribunaux compétents du ressort de Dijon seront seuls compétents.
          </p>
        </Section>
      </>
    ),
  },
  "politique-de-cookies": {
    overline: "Cookies",
    title: "Politique de cookies",
    content: (
      <>
        <Section title="Qu'est-ce qu'un cookie ?">
          <p>
            Un cookie est un petit fichier déposé sur votre appareil lors de la consultation d'un
            site. Il permet d'assurer son bon fonctionnement et, avec votre consentement, d'en
            mesurer l'audience.
          </p>
        </Section>
        <Section title="Cookies utilisés">
          <p>
            <strong className="text-ivory">Cookies nécessaires :</strong> indispensables au
            fonctionnement du site (mémorisation de vos choix de confidentialité, sécurité). Ils ne
            nécessitent pas de consentement.
          </p>
          <p>
            <strong className="text-ivory">Cookies statistiques :</strong> mesure d'audience
            anonymisée, déposés uniquement avec votre accord.
          </p>
          <p>
            <strong className="text-ivory">Cookies marketing :</strong> contenus tiers et réseaux
            sociaux, déposés uniquement avec votre accord.
          </p>
        </Section>
        <Section title="Durée de conservation">
          <p>
            Votre choix concernant les cookies est conservé pour une durée maximale de 6 mois,
            conformément aux recommandations de la CNIL. Passé ce délai, votre consentement vous
            sera à nouveau demandé.
          </p>
        </Section>
        <Section title="Gérer vos préférences">
          <p>
            Vous pouvez modifier votre choix à tout moment depuis la page « Gestion des cookies »
            accessible en bas de chaque page du site.
          </p>
        </Section>
      </>
    ),
  },
  "gestion-des-cookies": {
    overline: "Vos préférences",
    title: "Gestion des cookies",
    content: null,
  },
};

const GIFT_LOYALTY_CGV = (
  <>
    <Section title="Cartes cadeaux — validité et expiration">
      <p>
        Les cartes cadeaux Palais Maasaï sont valables pendant la durée indiquée au moment de
        l'achat (par défaut 12 mois à compter de la date d'achat), la date exacte d'expiration
        figurant sur la carte, dans l'email de confirmation et dans l'espace client.
      </p>
      <p>
        Après cette date, la carte cadeau et son éventuel solde restant expirent automatiquement.
        Le solde non utilisé n'est ni remboursable ni échangeable, sous réserve des dispositions
        légales impératives applicables.
      </p>
      <p>
        La carte est utilisable en une ou plusieurs fois, jusqu'à épuisement du solde. Elle n'est
        ni échangeable contre des espèces, ni rechargée. En cas de perte, de vol ou de transmission
        du numéro ou du QR code à un tiers, la responsabilité du restaurant ne saurait être engagée :
        la carte est un titre au porteur.
      </p>
    </Section>
    <Section title="Cartes cadeaux — prix, frais et remboursement">
      <p>
        Le bénéficiaire reçoit toujours la valeur faciale de la carte : les frais de paiement en
        ligne sont intégralement supportés par l'établissement et ne sont jamais déduits du montant
        offert. Aucun frais caché n'est ajouté au moment du paiement.
      </p>
      <p>
        Avant la date d'expiration, un remboursement n'est possible que lorsque la loi l'impose,
        lorsque les présentes conditions le prévoient, ou sur autorisation expresse de la direction.
        Une carte déjà partiellement utilisée ne peut être remboursée qu'à hauteur de son solde
        restant, sur décision de la direction. Conformément au Code de la consommation, le droit de
        rétractation de 14 jours s'applique aux achats en ligne lorsqu'il est légalement applicable,
        tant que la carte n'a pas été utilisée.
      </p>
      <p>
        En cas de problème technique ou de suspicion de fraude, l'établissement peut suspendre
        temporairement une carte le temps des vérifications nécessaires.
      </p>
    </Section>
    <Section title="Programme de fidélité">
      <p>
        Le programme de fidélité permet de cumuler des points à chaque paiement confirmé en ligne ou
        validé sur place (barème en vigueur affiché sur la page Fidélité). Les points peuvent être
        convertis en bons de réduction selon le seuil affiché.
      </p>
      <p>
        En cas de remboursement ou d'annulation d'un achat, les points correspondants sont retirés.
        Les corrections manuelles effectuées par l'établissement sont tracées (motif, date, auteur).
        Les points et récompenses sont personnels, non cessibles et non échangeables contre des
        espèces. L'établissement se réserve la possibilité de faire évoluer ou d'interrompre le
        programme, les points acquis restant utilisables pendant une période raisonnable.
      </p>
    </Section>
  </>
);

export default function Legal({ page }) {
  const settings = useSettings();
  const content = PAGES[page];
  const customCgv = page === "cgv" && settings?.texts?.cgv;

  if (page === "gestion-des-cookies") {
    return (
      <div data-testid="legal-gestion-cookies">
        <PageHero overline="Vos préférences" title="Gestion des cookies" testId="legal-hero">
          <p>
            Vous pouvez à tout moment revoir et modifier vos choix concernant les cookies déposés
            sur ce site.
          </p>
        </PageHero>
        <section className="px-6 pb-28 md:px-12 md:pb-40">
          <div className="mx-auto max-w-3xl">
            <Reveal>
              <div className="rounded-lg border border-white/10 bg-coal/60 p-10 text-center">
                <p className="text-sm leading-relaxed text-ivory/55">
                  Cliquez sur le bouton ci-dessous pour ouvrir le panneau de préférences et ajuster
                  votre consentement (statistiques, marketing). Les cookies strictement nécessaires
                  au fonctionnement du site restent toujours actifs.
                </p>
                <button
                  onClick={() => window.dispatchEvent(new Event("pm:open-cookie-prefs"))}
                  className="btn-primary mt-8"
                  data-testid="open-cookie-prefs-button"
                >
                  Modifier mes préférences
                </button>
              </div>
            </Reveal>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div data-testid={`legal-${page}`}>
      <PageHero overline={content.overline} title={content.title} testId="legal-hero" />
      <section className="px-6 pb-28 md:px-12 md:pb-40">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            {customCgv ? (
              <div className="space-y-4 text-sm leading-relaxed text-ivory/55" data-testid="cgv-custom">
                {settings.texts.cgv.split("\n\n").map((para, i) => (
                  <p key={i}>{para}</p>
                ))}
              </div>
            ) : (
              content.content
            )}
            {page === "cgv" && <div className="mt-2" data-testid="cgv-gift-loyalty">{GIFT_LOYALTY_CGV}</div>}
          </Reveal>
        </div>
      </section>
    </div>
  );
}
